module.exports = __webpack_public_path__ + "static/media/td.98d51272.svg";